import DocumentCard from "@components/DocumentCard/DocumentCard";
import CustomFormLabel from "@components/FormItem/FormItem.styles";
import SideDrawer from "@components/SimpleSideDrawer/SideDrawer";
import { useTranslation } from "react-i18next";
import { useDownloadNominationDocument } from "../../hooks/useDownloadNominationDocument";
import { LANG_BASE, TEST_ID_BASE } from "../../VesselNominationDetails";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  noteText?: string;
  attachmentUrl?: string;
  attachmentName?: string;
};

const ApprovalDetails = ({ isOpen, onClose, noteText, attachmentUrl, attachmentName }: Props) => {
  const { t } = useTranslation();
  const { handleDownload, handlePreview } = useDownloadNominationDocument();

  return (
    <SideDrawer
      isOpen={isOpen}
      onClose={onClose}
      keepMounted={false}
      title={t(`${LANG_BASE}.approval.details-title`)}
      hideCancelButton={true}
      submitLabel={t("common.ok")}
      onSubmit={onClose}
    >
      <div className="flex flex-col gap-4 w-[400px] p-6">
        {noteText && (
          <div className="col-span-full mb-2 flex flex-col gap-2">
            <CustomFormLabel sx={{ fontSize: 16, fontWeight: 700 }} data-testid="labelId">
              {t(`${LANG_BASE}.approval.comments`)}
            </CustomFormLabel>
            <p
              className="text-sm whitespace-pre-wrap wrap-break-word"
              data-testid={`${TEST_ID_BASE}-static-content`}
            >
              {noteText}
            </p>
          </div>
        )}
        {attachmentUrl && (
          <div className="col-span-full mb-2 flex flex-col gap-2">
            <CustomFormLabel sx={{ fontSize: 16, fontWeight: 700 }} data-testid="labelId">
              {t(`${LANG_BASE}.approval.attachments`)}
            </CustomFormLabel>
            <DocumentCard
              data-testid={`${TEST_ID_BASE}-external-attachment`}
              documentName={attachmentName}
              fileName={""}
              onDownload={() => {
                handleDownload("bff-vessel", attachmentUrl, attachmentName);
              }}
              onPreview={() => handlePreview("bff-vessel", attachmentUrl)}
            />
          </div>
        )}
      </div>
    </SideDrawer>
  );
};

export default ApprovalDetails;
